// import axios from 'axios';

// axios.defaults.withCredentials = true;

// export default axios;
import axios from 'axios';

// Set default credentials
axios.defaults.withCredentials = true;

// Add request interceptor to automatically include company from localStorage
axios.interceptors.request.use(
  (config) => {
    // Get company from localStorage
    let company = localStorage.getItem('company');

    if (company === 'MIAH & SONS INDUSTRIES LTD.') {
      company = "Miah & Son's";
    } else if (company === 'Tanvir Printing & Packaging IND.') {
      company = 'Tanvir Pack';
    } else if (company === 'Propack Trims & Accessories Industries') {
      company = 'ProPack';
    }

    // Only add company to GET request params
    if (company && config.method === 'get') {
      config.params = {
        ...config.params,
        company: company
      };
    }

    // // Case 2: POST/PUT requests
    if (company && (config.method === 'post' || config.method === 'put')) {
      
      // CRITICAL FIX HERE: Check if data is an Array
      if (Array.isArray(config.data)) {
        // If data is an Array, DO NOT merge into body (it breaks the array).
        // Instead, send company in the Query String (params).
        config.params = {
            ...config.params,
            company: company
        };
      } else {
        // If data is a regular Object, we can safely merge company into it.
        config.data = {
            ...config.data,
            company: company 
        };
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
